import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/public_scopes');
  return response.data;
}

export default {
  index,
};
